import * as Yup from "yup";
import { useTranslation } from "react-i18next";

export const useRegisterValidationSchema = () => {
    const { t } = useTranslation();

    return Yup.object({
        referrerNumber: Yup.string()
            .required(t("Register.Validation.ReferrerNumberRequired"))
            .matches(/^\d{10}$/, t("Register.Validation.ReferrerNumber10Digits")),
        fullName: Yup.string()
            .required(t("Register.Validation.FullNameRequired"))
            .matches(/^\S+(?:\s+\S+)+$/, t("Register.Validation.FullNameRequired")),
        mobile: Yup.string().required(t("Register.Validation.MobileRequired"))
            .matches(/^\+\d+$/, t("Register.Validation.MobileFormat")),
        email: Yup.string()
            .email(t("Register.Validation.EmailInvalid"))
            .required(t("Register.Validation.EmailRequired")),
        country: Yup.string().required(t("Register.Validation.CountryRequired")),
        city: Yup.string().required(t("Register.Validation.CityRequired")),
        password: Yup.string()
            .min(6, t("Register.Validation.PasswordMin"))
            .matches(/\d/, t("Register.Validation.PasswordDigit"))
            .matches(/[a-zA-Z]/, t("Register.Validation.PasswordLetter"))
            .required(t("Register.Validation.PasswordRequired")),

        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password")], t("Register.Validation.ConfirmPasswordMatch"))
            .required(t("Register.Validation.ConfirmPasswordRequired")),
    });
};

